import { useLocation } from "react-router";

export function useLocationString() {
  const location = useLocation();

  return [location.pathname, location.search, location.hash].join("");
}
